import React, { useCallback, useMemo } from 'react'
import useLocalStorageState from 'use-local-storage-state'
import type { ReviewDogInfoSchema } from '../components/dogForm/ReviewDogInfoSchema'
import { useLocalStorageReviewDogInfo } from '../components/shared/ReviewForm'
import { useAuth } from './UserContext'
import { dogResultToDogInfo } from './dogResultToDogInfo'

export function useReviewFormDog() {
	const auth = useAuth()
	const user = auth.status === 'signedIn' ? auth.user : null

	const [localStorageReviewDogInfo, setLocalStorageReviewDogInfo, clearLocalStorageReviewDogInfo] =
		useLocalStorageReviewDogInfo()

	const [activeDogId, setActiveDogId] = useLocalStorageState(`${user?.id}/activeDogId`)

	const dogEntity = React.useMemo(() => {
		if (user) {
			const mostRecentDog = user.dogs?.sort(
				(a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
			)[0]
			return activeDogId ? user.dogs?.find((dog) => dog.id === activeDogId) : (mostRecentDog ?? null)
		}
		return null
	}, [activeDogId, user])

	const dogInfo = useMemo(() => {
		return dogEntity ? dogResultToDogInfo(dogEntity) : null
	}, [dogEntity])

	const saveActiveDog = useCallback(
		(dog: null | ReviewDogInfoSchema) => {
			if (!dog) {
				setActiveDogId(null)
				clearLocalStorageReviewDogInfo()
			} else {
				setLocalStorageReviewDogInfo(dog)
			}
		},
		[clearLocalStorageReviewDogInfo, setActiveDogId, setLocalStorageReviewDogInfo],
	)

	const removeActiveDog = () => {
		clearLocalStorageReviewDogInfo()
	}

	const isUserDog = localStorageReviewDogInfo?.userId === user?.id

	return {
		reviewDog: isUserDog
			? localStorageReviewDogInfo
				? localStorageReviewDogInfo
				: auth.status === 'signedIn'
					? dogInfo
					: null
			: auth.status === 'signedIn'
				? dogInfo
				: null,
		saveActiveDog,
		removeActiveDog,
	}
}
